import { Pipe, PipeTransform, inject } from '@angular/core';
import { AUTH_CONTEXT } from '../../core/tokens';

/**
 * Maskiert sensible Daten für Gäste und nicht angemeldete Nutzer.
 *
 * Verwendung: {{ value | maskForGuest }}
 * Oder mit benutzerdefiniertem Ersatztext: {{ value | maskForGuest:'***' }}
 */
@Pipe({
	name: 'maskForGuest',
	pure: false,  // Muss impure sein, damit Änderungen am Auth-Status erkannt werden
	standalone: true
})
export class MaskForGuestPipe implements PipeTransform {
	private auth = inject(AUTH_CONTEXT);

	transform(value: any, placeholder: string = '–'): any {
		// Gäste und nicht authentifizierte Nutzer sehen maskierte Werte
		if (this.auth.amI('gast') || !this.auth.isAuthenticated.getValue()) {
			return placeholder;
		}
		return value;
	}
}
